import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
(function(IRetailer) {
    (function(BusinessCategory) {
        BusinessCategory["BUSINESS_CATEGORY_UNKNOWN"] = "BUSINESS_CATEGORY_UNKNOWN";
        BusinessCategory["BUSINESS_OTHER"] = "BUSINESS_OTHER";
        BusinessCategory["BRICK_AND_MORTAR"] = "BRICK_AND_MORTAR";
        BusinessCategory["ONLINE_ONLY"] = "ONLINE_ONLY";
        BusinessCategory["POP_UP"] = "POP_UP";
    })(IRetailer.BusinessCategory || (IRetailer.BusinessCategory = {}));
    (function(ReportedCreationTime) {
        ReportedCreationTime["OPENING_SOON"] = "OPENING_SOON";
        /**
     * @deprecated
     */ ReportedCreationTime["STARTED_IN_2018"] = "STARTED_IN_2018";
        /**
     * @deprecated
     */ ReportedCreationTime["BETWEEN_2013_AND_2017"] = "BETWEEN_2013_AND_2017";
        /**
     * @deprecated
     */ ReportedCreationTime["BEFORE_2013"] = "BEFORE_2013";
        ReportedCreationTime["STARTED_THIS_YEAR"] = "STARTED_THIS_YEAR";
        /**
     * @deprecated
     */ ReportedCreationTime["BETWEEN_5_AND_1_YEAR_AGO"] = "BETWEEN_5_AND_1_YEAR_AGO";
        ReportedCreationTime["BEFORE_5_YEAR_AGO"] = "BEFORE_5_YEAR_AGO";
        ReportedCreationTime["STARTED_ONE_YEAR_AGO"] = "STARTED_ONE_YEAR_AGO";
        ReportedCreationTime["STARTED_TWO_YEARS_AGO"] = "STARTED_TWO_YEARS_AGO";
        ReportedCreationTime["STARTED_THREE_YEARS_AGO"] = "STARTED_THREE_YEARS_AGO";
        ReportedCreationTime["STARTED_FOUR_YEARS_AGO"] = "STARTED_FOUR_YEARS_AGO";
        /**
     * @deprecated
     */ ReportedCreationTime["STARTED_BEFORE_FOUR_YEARS_AGO"] = "STARTED_BEFORE_FOUR_YEARS_AGO";
        ReportedCreationTime["STARTED_BETWEEN_5_AND_2_YEAR_AGO"] = "STARTED_BETWEEN_5_AND_2_YEAR_AGO";
        ReportedCreationTime["STARTED_FIVE_YEARS_AGO"] = "STARTED_FIVE_YEARS_AGO";
    })(IRetailer.ReportedCreationTime || (IRetailer.ReportedCreationTime = {}));
    (function(NeverClawbackReturnsReason) {
        NeverClawbackReturnsReason["HIGH_VALUE"] = "HIGH_VALUE";
        NeverClawbackReturnsReason["STRATEGIC_PARTNER"] = "STRATEGIC_PARTNER";
        NeverClawbackReturnsReason["HIGH_RISK"] = "HIGH_RISK";
        NeverClawbackReturnsReason["OTHER"] = "OTHER";
    })(IRetailer.NeverClawbackReturnsReason || (IRetailer.NeverClawbackReturnsReason = {}));
    (function(InsiderMembershipState) {
        /**
     * Excluded from insider due to experiment
     */ InsiderMembershipState["NOT_ELIGIBLE"] = "NOT_ELIGIBLE";
        /**
     * Eligible but have never had insider -- will purchase free trial first
     */ InsiderMembershipState["ELIGIBLE"] = "ELIGIBLE";
        /**
     * Currently active with insider on a TRIALING or ACTIVE membership
     */ InsiderMembershipState["ACTIVE"] = "ACTIVE";
        /**
     * Previously active with a CANCELLED membership
     */ InsiderMembershipState["CHURNED"] = "CHURNED";
        /**
     * Previously active with an UNPAID membership
     */ InsiderMembershipState["UNPAID"] = "UNPAID";
        /**
     * Previously active with an PAUSED membership
     */ InsiderMembershipState["PAUSED"] = "PAUSED";
    })(IRetailer.InsiderMembershipState || (IRetailer.InsiderMembershipState = {}));
    (function(IdentityConfirmedBy) {
        /**
     * Required by test
     */ IdentityConfirmedBy["IDENTITY_CONFIRMED_BY_UNKNOWN"] = "IDENTITY_CONFIRMED_BY_UNKNOWN";
        /**
     * Retailer confirmed through an IDV heuristic
     */ IdentityConfirmedBy["HEURISTICS"] = "HEURISTICS";
        /**
     * Retailer confirmed through the IDV model
     */ IdentityConfirmedBy["MODEL"] = "MODEL";
        /**
     * Retailer confirmed through admin
     */ IdentityConfirmedBy["ADMIN"] = "ADMIN";
        /**
     * Unsure how retailer was confirmed
     */ IdentityConfirmedBy["UNSURE"] = "UNSURE";
    })(IRetailer.IdentityConfirmedBy || (IRetailer.IdentityConfirmedBy = {}));
    (function(MultiUserState) {
        MultiUserState["MULTI_USER_STATE_UNKNOWN"] = "MULTI_USER_STATE_UNKNOWN";
        /**
     * Retailer has never invited a sub-user
     * @deprecated
     */ MultiUserState["NOT_MULTI_USER"] = "NOT_MULTI_USER";
        /**
     * Retailer has invited at least one sub-user. The invitation may or may not currently be valid
     */ MultiUserState["HAS_INVITED_SUBUSER"] = "HAS_INVITED_SUBUSER";
        /**
     * Retailer has no active sub-users, but at least one pending invite
     * @deprecated
     */ MultiUserState["HAS_INVITED_PENDING_SUBUSER"] = "HAS_INVITED_PENDING_SUBUSER";
        /**
     * Retailer currently has active sub-users
     */ MultiUserState["HAS_ACTIVE_SUBUSER"] = "HAS_ACTIVE_SUBUSER";
        /**
     * Retailer has had at least one active sub-user before. The retailer may or may not currently have active sub-users
     */ MultiUserState["HAS_EVER_HAD_ACTIVE_SUB_USER"] = "HAS_EVER_HAD_ACTIVE_SUB_USER";
    })(IRetailer.MultiUserState || (IRetailer.MultiUserState = {}));
    (function(MultiStoreStatus) {
        MultiStoreStatus["MULTI_STORE_STATUS_UNKNOWN"] = "MULTI_STORE_STATUS_UNKNOWN";
        /**
     * Retailer currently has multiple non-deleted store
     */ MultiStoreStatus["HAS_MULTIPLE_STORES"] = "HAS_MULTIPLE_STORES";
        /**
     * Retailer has had at least one active non-default-store before. The retailer may or may not currently have multiple non-deleted stores
     */ MultiStoreStatus["HAS_EVER_HAD_MULTIPLE_STORES"] = "HAS_EVER_HAD_MULTIPLE_STORES";
    })(IRetailer.MultiStoreStatus || (IRetailer.MultiStoreStatus = {}));
    IRetailer.build = function(partial) {
        return _object_spread({
            categories: [],
            images: [],
            memberships: [],
            order_minimum_overrides: [],
            business_identifiers: [],
            default_store_business_identifiers: [],
            available_memberships: [],
            multi_user_states: [],
            business_platforms: [],
            multi_store_statuses: []
        }, partial !== null && partial !== void 0 ? partial : {});
    };
})(IRetailer || (IRetailer = {}));
export var IRetailer;
